import AnswersTo1099RFaq from './answersTo1099RFaq';

export default AnswersTo1099RFaq;
